import React from 'react';
import { Pivot, PivotItem } from '@fluentui/react';
import MasterDataManagers from './MasterDataManagers';
import CountryEmailNotifications from './CountryEmailNotifications';
import BaServiceLeads from './BaServiceLeads';
import { addPivotItemKeyToUrl, getPivotItemKeyFromUrl } from '../../helpers/HelperMethods';

const MasterDataManagersPanel = ({parentPivotKey}) => {

    
    const defaultSelectedKey = getPivotItemKeyFromUrl('DivisionManagers', parentPivotKey);

    return (
        <div>
            <Pivot styles={pivotStyles} onLinkClick={addPivotItemKeyToUrl(parentPivotKey)} defaultSelectedKey={defaultSelectedKey}>
                <PivotItem headerText='Division Managers' itemKey='DivisionManagers'>
                    <MasterDataManagers
                        getEndpoint='/Settings/ManagementManagers'
                        saveEndpoint='/Settings/ManagementManagers'
                        depth={2}
                        onItemNameRender={(management) => `${management.value} (${management.key})`}
                        groupByProperty='parentKey'
                        keyProperty='key'
                        onHeaderNameRender={(management) => `${management.value} (${management.key})`}
                    />
                </PivotItem>
                <PivotItem headerText='Country Managers' itemKey='CountryManagers'>
                    <MasterDataManagers
                        getEndpoint='/Settings/CountryManagers'
                        saveEndpoint='/Settings/CountryManagers'
                        depth={2}
                        onItemNameRender={(country) => `${country.value} (${country.key})`}
                        groupByProperty='parentKey'
                        keyProperty='key'
                        onHeaderNameRender={(country) => `${country.value} (${country.key})`}
                    />
                </PivotItem>
                <PivotItem headerText='Country Email Notifications' itemKey='CountryEmailNotifications'>
                    <CountryEmailNotifications
                        getEndpoint='/Settings/CountryNotificationSettings'
                        saveEndpoint='/Settings/CountryNotificationSettings'
                        depth={2}
                        onItemNameRender={(country) => `${country.value} (${country.key})`}
                        groupByProperty='parentKey'
                        keyProperty='key'
                        onHeaderNameRender={(country) => `${country.value} (${country.key})`}
                    />
                </PivotItem>
                <PivotItem headerText='BA Service Leads & System Admins' itemKey='BaServiceLeads'>
                    <BaServiceLeads />
                </PivotItem>
            </Pivot>
        </div>
    );
}

const pivotStyles = {
    root: {
        marginBottom: 20
    },
    linkContent: {
        fontSize: 16,
    }
}

export default MasterDataManagersPanel;



// WEBPACK FOOTER //
// ./src/components/Settings/MasterDataManagersPanel.js